<template>

  <main dir="rtl" class="page-wrapper d-flex justify-content-center align-items-center bg__main">

    <!-- Page content -->
    <div class="container" style="margin-top: 3%;">
      <!-- Page content -->
      <div class="row">
        <!-- Main box -->
        <div class="col-lg-11 mb-5 m-auto" :style="isLoading ? 'filter: blur(0.2vw)' : ''">


          <div class="row">
            <div class="col-lg-4 login-form d-flex justify-content-center align-items-center">
              <form action="" class="form">
                <h1 class="mt-5">به سامانه جامع و یکپارچه بهفام خوش آمدید</h1>
                <div class="form-group mt-50 mb-4 mt-5-5">
                  <label style="font-size: 1vw" class="form-label"> نام‌ کاربری </label>
                  <input style="width: 18vw;" v-model="username" class="form-input" type="text"/>
                </div>
                <div class="form-group mt-50 mb-4 mt-5-5">
                  <label style="font-size: 1vw" class="form-label">رمز عبور</label>
                  <input style="width: 18vw;" v-model="password" class="form-input" type="password"/>
                </div>
                <div class="login__card--form__code mt-50 mb-4 mt-5-5"
                     style="display:flex; align-items: center">
                  <div class="form-group">
                    <label style="font-size: 1vw" class="form-label">کد امنیتی </label>
                    <input style="width: 14vw;" v-model="inputCode" maxlength="4" class="form-input input__code" type="text"/>
                  </div>

                  <div class="login__card--form__code--box">
                    <captcha-code

                        style="width: 10vw; max-width: 8vw; border-radius: .5vw; direction: ltr"
                        @on-change="handleChange"
                        ref="captcha"
                        bg-color="white"
                        font-size="20"
                        char-num="4"
                        width="100"


                    ></captcha-code>

                  </div>
                </div>
                <center>
                  <button style="position:relative; display:flex !important;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: center;
" @click.prevent="handleClick()" class="btn btn-primary btn-login mb-5 m-auto" type="submit">ورود<span v-show="isLoading" class="loader"></span></button>  </center>

              </form>

            </div>
            <div class="col-lg-8 login-image d-flex justify-content-center align-items-center img_bg" style="background-color: #fff;">

            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- modal  -->

    <!-- modal  -->
    <!-- modal  -->
    <div class="modal__error" v-show="EmptycodeError">
      <div>
        <p>خطا</p>
        <p @click="EmptycodeError=!EmptycodeError">❌</p>
      </div>
      <div>
        <p>کد امنیتی را وارد کنید!</p>
        <button @click="EmptycodeError=!EmptycodeError">تایید</button>
      </div>
    </div>
    <!-- modal  -->
    <!-- modal  -->
    <div class="modal__error" v-show="UsernameError">
      <div>
        <p>خطا</p>
        <p @click="UsernameError=!UsernameError">❌</p>
      </div>
      <div>
        <p>{{UsernameErrorM}}</p>
        <button @click="UsernameError=!UsernameError">تایید</button>
      </div>
    </div>
    <!-- modal  -->
    <!-- modal  -->

    <!-- modal  -->
  </main>
</template>

<script>
import CaptchaCode from 'vue-captcha-code';
import router from "@/router";
import cookies from "vue-cookies";
import {useToast} from "vue-toastification";
const toast = useToast();


export default {
  name: "Login",
  components: {
    CaptchaCode,
  },
  data() {
    return {
      username: null,
      password: null,
      code: '',
      inputCode: "",
      codeError: false,
      EmptycodeError: false,
      UsernameError: false,
      UsernameErrorM: '',
      PasswordError: false,
      PasswordErrorM: false,
      isLoading: false,
    }
  },
  methods: {
    handleClick() {
      this.isLoading = !this.isLoading
      setTimeout(() => {
        this.isLoading = !this.isLoading

        if (!this.username) {
          this.UsernameErrorM = "نام کاربری نمیتواند خالی باشد!"
          toast.error(this.UsernameErrorM)
        } else if (!this.password) {
          this.PasswordErrorM = "پسورد نمیتواند خالی باشد!"
          toast.error(this.PasswordErrorM)

        } else if (this.inputCode.length !== 4) {
          toast.error('کد امنیتی اشتباه است')

        } else if (this.code !== this.inputCode) {
          toast.error('کد امنیتی اشتباه است')

          this.$refs.captcha.refreshCaptcha()
          this.codeError = !this.codeError
        } else {
          fetch(`${this.base_url}/auth/login`, {
            method: 'POST',
            headers: {
              'Content-type': 'application/json; charset=UTF-8',
            },
            body: JSON.stringify({
              'username': this.username,
              'password': this.password,
            }),
          }).then(response => response.json()).then((response) => {
            if (response['error']) {
              this.UsernameErrorM = response['error']
              toast.error(this.UsernameErrorM)

            } else if (response['token']) {
              this.$store.commit('login', `${response['token']}`)
              if(response['is_mother']){
                cookies.set('is_mother', response['is_mother'], "3y")
              }
              window.location.reload()
              router.push('/pishkhan')
            }
          }).catch((err) => {
            // console.log(err)
          })
        }
      }, 1000)
    },
    handleChange(code) {
      this.code = code
    },
  }
  ,
  mounted() {


    $('input').focus(function () {
      $(this).parents('.form-group').addClass('focused');
    });

    $('input').blur(function () {
      var inputValue = $(this).val();
      if (inputValue == "") {
        $(this).removeClass('filled');
        $(this).parents('.form-group').removeClass('focused');
      } else {
        $(this).addClass('filled');
      }
    })
  }
}
</script>

<style scoped lang="scss">
.img_bg{
  background-image: url(../../assets/img/login.png);
  background-size: 32vw;
  background-repeat: no-repeat;
  background-position:  center;
}
.bg__main{
  background-image: url(../../assets/img/bg_login.png);
  background-size: cover;
  background-position:  center;
  background-repeat: no-repeat;
  height: 100vh;
  overflow-y: hidden;
}
/* CSS for floating label */
.form-group {
  position: relative; }
.form-group + .form-group {
  margin-top: 1vw; }
.form-label {
  position: absolute;
  right: 0;
  top: 15px;
  color: #3742FA;
  z-index: 10;
  transition: transform 150ms ease-out, font-size 150ms ease-out;
}

.focused .form-label {
  transform: translateY(-125%);
  font-size: .75em;
}

.form-input {
  margin-top: .5vw;
  position: relative;
  padding: 1vw 0px 5px 0;
  width: 70vw;
  outline: 0;
  border: 0;
  box-shadow: 0 1px 0 0 #3742FA;
  transition: box-shadow 150ms ease-out;
  border-bottom: .3vw solid #3742FA;
  background: transparent; }
.form-input:focus {
  box-shadow: 0 2px 0 0 #3742FA; }

.form-input.filled {
  box-shadow: 0 2px 0 0 lightgreen; }
.form-group{
  background-color: unset;
  box-shadow: unset;
  border: unset;
;
}
.login__card--form__code--box {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5vw;
  cursor: pointer;
  user-select: none;
  font-weight: bolder;
  margin-top: 1vw;

}
.mt-5-5{
  margin-top: 3vw !important;
}
input{
  font-size: 1vw;
}
.loading{
  background-color: rgba(#fff, .5);
  width: 82.5vw;
  height: 42.40vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 104px 58px 64px 54px;
  z-index: 9999;

}
.modal__error {
  background-color: #cfe4f1;
  width: 30vw;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 1.3vw;
  padding: 1.1vw;
  box-shadow: 0 0 3px 2px #eee;

  & > div:first-child {
    display: flex;
    justify-content: space-between;
    align-items: center;

    & > p {
      font-family: Shabnam;
      font-size: 1.1vw;
      &:nth-child(2){
        cursor: pointer;
      }

    }
  }

  & > div:last-child {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    & > p {
      font-size: 1.1vw;
      font-family: Shabnam;

    }

    & > button {
      font-size: 1vw;
      width: 8vw;
      background-color: #3742FA;
      color: #fff;
      border: unset;
      border-radius: .5vw;
      height: 2vw;
      margin-top: 2.5vw;
      margin-bottom: 2.5vw;
      cursor: pointer;
      font-family: Shabnam;




    }
  }
}
</style>